module.exports = __webpack_public_path__ + "media/invest/uncorrelated-asset-257da2e8.png";